import "./Investments.module.css";
import Header from "@/reusable_sections/Header";
import OurWorkInFrames from "./sections/OurWorkInFrames";
import PerformanceMetrics from "./sections/PerformanceMetrics";
import Footer from "@/reusable_sections/Footer";
export default function InvestmentsPage() {
  return <div>
      <Header />
      <OurWorkInFrames />
      <PerformanceMetrics />
      <Footer />
    </div>;
}